import { FC, useEffect, useMemo, useState } from 'react'
import styles from 'components/features/rewards/rewardPage/CryptoChartPreset/CryptoChartPreset.styl'
import { ResizeHandler } from 'handlers/ResizeHandler/ResizeHandler'
import { ChartInteraction } from 'components/atoms/chart/ChartInteraction/ChartInteraction'
import { CryptoChartsContexts, Size } from 'components/features/rewards/rewardPage/useCryptoChartContext'
import { ChartAxisPreset } from 'components/features/rewards/rewardPage/ChartAxisPreset/ChartAxisPreset'

const X_AXIS_HEIGHT = 41

type CryptoChartPresetProps = {
  contexts: CryptoChartsContexts
  onSize: (size: Size) => void
  onHover: (index: number) => void
}
export const CryptoChartPreset: FC<CryptoChartPresetProps> = (props) => {
  const { contexts, onHover, onSize, children } = props

  const [size, setSize] = useState({ width: 0, height: 0 })
  const chartSize = useMemo(() => {
    const { width, height } = size
    return {
      width,
      height: height - X_AXIS_HEIGHT,
    }
  }, [size])

  useEffect(() => {
    onSize(chartSize)
  }, [chartSize, chartSize.height, chartSize.width, onSize])

  return (
    <ResizeHandler
      onChange={ setSize }
      className={ styles.chartWrapper }
    >
      { size.width !== 0 && size.height !== 0 && (
        <ChartInteraction
          className={ styles.summaryChart }
          context={ contexts.chartContext }
          onChange={ onHover }
        >
          <svg className={ styles.svg }>
            { children }
            <ChartAxisPreset context={ contexts.monthlyUsdContext } height={ chartSize.height } width={ chartSize.width } />
          </svg>
        </ChartInteraction>
      )}
    </ResizeHandler>
  )
}
